package kz.dentalcrm.app.navigation

/**
 * Internal navigation commands produced by [AppNavigator] and consumed by its implementation.
 * 
 * These commands represent the "intent" of navigation. The navigator implementation is responsible for:
 * - applying the command to the Navigation 3 back stack
 * - publishing results to [NavigationResults] when applicable
 */
internal sealed interface NavCommand {

    /** Pop one entry from the back stack (no-op if at root). */
    data object NavigateUp : NavCommand

    /** Push [destination] on top of the back stack. */
    data class NavigateTo(val destination: AppRoute) : NavCommand

    /** Clear stack and set [destination] as the only entry. */
    data class NavigateAndClear(val destination: AppRoute) : NavCommand

    /** Pop until [destination] becomes top; optionally remove it too. */
    data class PopUpTo(val destination: AppRoute, val inclusive: Boolean) : NavCommand

    /**
     * Pop one entry and publish a navigation result under [key].
     * 
     * @param destination optional target for more advanced implementations (e.g. pop to a screen).
     */
    data class NavigateUpWithResult(
        val key: String,
        val value: Any,
        val destination: AppRoute?,
    ) : NavCommand
}
